import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  IconButton,
  Flex,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

const SupplierList = ({ suppliers, onEdit, onDelete }) => {
  return (
    <>
      {suppliers.map((supplier) => (
        <Box
          key={supplier.id}
          p="4"
          borderWidth="1px"
          borderRadius="md"
          bg="gray.50"
          boxShadow="md"
          _hover={{ bg: 'gray.100' }}
        >
          <Flex justify="space-between" align="center">
            <VStack align="start" spacing="2">
              <Text fontWeight="bold">{supplier.name || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">Email: {supplier.email || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">Телефон: {supplier.phone_number || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">ЄДРПОУ: {supplier.edrpou_code || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">Адреса: {supplier.address || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">Банк: {supplier.bank_name || 'N/A'}</Text>
              <Text fontSize="sm" color="gray.600">Рахунок: {supplier.bank_number || 'N/A'}</Text>
              <Text fontSize="xs" color="gray.400">
                Створено: {supplier.created_at || 'N/A'}
              </Text>
              <Text fontSize="xs" color="gray.400">
                Оновлено: {supplier.updated_at || 'N/A'}
              </Text>
            </VStack>
            <HStack>
              <IconButton
                icon={<EditIcon />}
                size="sm"
                variant="outline"
                onClick={() => onEdit(supplier)}
                aria-label="Edit"
              />
              <IconButton
                icon={<DeleteIcon />}
                size="sm"
                variant="outline"
                colorScheme="red"
                onClick={() => onDelete(supplier)}
                aria-label="Delete"
              />
            </HStack>
          </Flex>
        </Box>
      ))}
    </>
  );
};

export default SupplierList;
